$(document).ready(function(){

// product page code    
  $('.custom_add_to_cart_btn.available').on('click', function () {
    var variantId = $('.gift_prd_id').val();
    var loader = $(this).find('.btn__loading-wrap');
    var isChecked = $('.gift_prd_id').prop('checked'); 
    loader.show();
    var gif_source = $('.product__block--product-header .product__title').text();
    var main_prd_option = $('span[data-selected-value-for-option]')
    var main_prd_option_text = main_prd_option.text();
    var mainPrdProperty = $('.main_prd_gift_property');
    var mainPrdPropertyYes = $('.main_prd_gift_property_yes');
    mainPrdProperty.attr('value', '');
    mainPrdPropertyYes.attr('value', '');
    if(main_prd_option.length == 0){
       //alert(gif_source);
    }else {
       gif_source = gif_source+" "+ main_prd_option_text;
       //alert(gif_source);
       
    }
    
    
    //alert(main_prd_option.length);

    if (isChecked) {
        // Create unique property value
         var uniqueCode = "U-" + Date.now();
         mainPrdProperty.attr('value', uniqueCode);
         mainPrdPropertyYes.attr('value', 'Yes');

        

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                id: variantId,
                quantity: 1,
                properties: {
                    // "Gift Wrapper": "Yes",
                    // "Wrapper Source": gif_source,
                    "Gift wrapper product": uniqueCode
                }
            },
            dataType: 'json',
            success: function () {
                $('.product-form__cart-submit').trigger('click');
                setTimeout(() => {
                    loader.hide();
                }, 2000);
            },
            error: function (err) {
                console.error(err);
            }
        });
    } else {

        // If checkbox NOT checked → only add the main product
        $('.product-form__cart-submit').trigger('click');
        setTimeout(() => {
            loader.hide();
        }, 2000);
    }
});



// cart code
$(document).on('change', '.gift_prd_id_cart', function () {
    var line_item_key = $(this).closest('.quick-cart__item').attr('data-key');
    var currentProductQty = $(this).closest('.quick-cart__item').find('.quantity-input__input').attr('value');
    var currentProductRemove = $(this).closest('.quick-cart__item').find('.quick-cart__item-remove');
    var variantId = $(this).val();
    var uniqueCode = "U-" + Date.now();
    $('.quick-cart__form').addClass('quick-cart__items_disable');
    if ($(this).is(':checked')) {
         
        //  mainPrdProperty.attr('value', uniqueCode);
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                id: variantId,
                quantity: 1,
                properties: {
                    // "Gift Wrapper": "Yes",
                    // "Wrapper Source": gif_source,
                    "Gift wrapper product": uniqueCode
                }
            },
            dataType: 'json',
            success: function () {
               
               $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: {
                    id: line_item_key,        
                    quantity: currentProductQty,             
                    properties: {
                    "Gift wrapper product": uniqueCode,
                    "Gift wrapper": "Yes",
                    }
                },
                success: function(cart) {
                    console.log(cart);
                    QuickCart.refreshQuickCart();
                    setTimeout(function(){
                      $('.quick-cart__form').removeClass('quick-cart__items_disable');
                    },1000);
                    
                }
                });

            },
            error: function (err) {
                console.error(err);
            }
        });
    } else {
        // alert('Not checked');
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
                id: line_item_key,        
                quantity: currentProductQty,             
                properties: {
                "Gift wrapper product": '',
                "Gift wrapper": "",
                }
            },
            success: function(cart) {
                console.log(cart);
                QuickCart.refreshQuickCart();
                    setTimeout(function(){
                      $('.quick-cart__form').removeClass('quick-cart__items_disable');
                    },1000);
                
            }
            });
    }
});


setInterval(() => {

    $('.quick-cart__item.gift_wrapper_cart').each(function () {
        var line_item_key = $(this).attr('data-key');
        var giftValue = $(this).find('.gift_product_added').attr('gift-wrapper-product');

        var nextValues = [];
        $('.quick-cart__item.not_gift_wrapper_cart').each(function () {
            nextValues.push($(this).find('.gift_product_added').attr('gift-wrapper-product'));

        });

        if(nextValues.indexOf(giftValue)!=-1){

        }
        else{
        //    alert("Not Matched: "+ giftValue); 
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
                id: line_item_key,        
                quantity: 0,             
                properties: {
                "Gift wrapper product": '',
                "Gift wrapper": "",
                }
            },
            success: function(cart) {
                console.log(cart);
                QuickCart.refreshQuickCart();

            }
            });
        }


    });

}, 3000);



});
